import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useNavigate, useLocation } from 'react-router-dom';
import { Circles } from 'react-loader-spinner'; // ✅ Import loader
import BASE_URL from '../config';

const MySwal = withReactContent(Swal);

const showToast = (icon, title, text) => {
  MySwal.fire({
    toast: true,
    position: 'top',
    icon,
    title,
    text,
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
  });
};

const Changepassword = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token') || '';
  const email = queryParams.get('email') || '';

  const [form, setForm] = useState({
    email: email,
    token: token,
    password: '',
    password_confirmation: '',
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false); // ✅ Loader state

  useEffect(() => {
    if (!token || !email) {
      showToast('error', 'Invalid Link', 'Missing token or email in URL');
      navigate('/forgot-password');
    }
  }, [token, email, navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const validate = () => {
    const newErrors = {};
    if (!form.password) newErrors.password = 'Password is required';
    if (!form.password_confirmation) newErrors.password_confirmation = 'Please confirm your password';
    if (form.password !== form.password_confirmation)
      newErrors.password_confirmation = 'Passwords do not match';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true); // ✅ Start loading

    try {
      const res = await axios.post(`${BASE_URL}/api/reset-password`, form, {
        headers: { Accept: 'application/json' },
      });
      showToast('success', 'Success', res.data.message || 'Password reset successful');
      navigate('/login');
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to reset password';
      showToast('error', 'Error', message);
    } finally {
      setLoading(false); // ✅ Stop loading
    }
  };

  return (
    <div className="loginscreen d-flex align-items-center justify-content-center">
      <div className="login-box p-4 shadow text-center" style={{ minWidth: '320px' }}>
        <h4 style={{ color: '#fff' }}>
          BI <span style={{ color: '#FF650F' }}>Manager</span>
        </h4>

        {loading ? (
          <div className="d-flex justify-content-center my-4">
            <Circles height="50" width="50" color="#FF650F" />
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <input type="hidden" name="email" value={form.email} />
            <input type="hidden" name="token" value={form.token} />

            <div className="form-group mb-3">
              <input
                type="password"
                name="password"
                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                placeholder="New Password"
                value={form.password}
                onChange={handleChange}
              />
              {errors.password && <div className="invalid-feedback">{errors.password}</div>}
            </div>

            <div className="form-group mb-3">
              <input
                type="password"
                name="password_confirmation"
                className={`form-control ${errors.password_confirmation ? 'is-invalid' : ''}`}
                placeholder="Confirm New Password"
                value={form.password_confirmation}
                onChange={handleChange}
              />
              {errors.password_confirmation && (
                <div className="invalid-feedback">{errors.password_confirmation}</div>
              )}
            </div>

            <button type="submit" className="btn btn-primary btn-block w-100">
              Reset Password
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Changepassword;
